<template>
<div>
  <Chart size="12" offset="0" title="Active Backlog" chart="column" chartType="backlog" :isCity="false" :withDate="false" :withFinancial="false" city="504" cityName="Jacksonville, FL. (Richard St)"/>
  <Chart size="12" offset="0" title="Delivered Equipment" chart="pie" chartType="Shipped" :isCity="false" :withDate="true" :withFinancial="true" :showExcel ="true" type="shipped" />
  <Chart size="12" offset="0" title="Beyond Economical Repair" chart="column" chartType="BER" :isCity="false" :withDate="true" :withFinancial="false" />
  <Chart size="12" offset="0" title="End Of Life" chart="column" chartType="EOL" :isCity="false" :withDate="true" :withFinancial="false" />
  <Chart size="12" offset="0" title="Under Warranty" chart="column" chartType="war" :isCity="false" :withDate="true" :withFinancial="false" />
  <Chart size="12" offset="0" title="Delivered Per Customer" chart="column" chartType="company" :isCity="false" :withDate="true" :withFinancial="false" :isCompanyOverall="true" />
  <Chart size="12" offset="0" title="Delivered Per Customer" chart="column" chartType="company" :isCity="false" :withDate="true" :withFinancial="false" :isCompanyProfile="true" company="Comcast" />
  <Chart size="12" offset="0" title="Active Backlog" chart="column" chartType="backlog" :isCity="false" :withDate="false" :withFinancial="false" model="fnsp003760" modelName="COS-RPL1-RFT-MU-A-01-01" />
  <ChartStacked size="12" offset="0" title="Repair Analytics" chartType="repair" :withDate="true" :withFinancial="false"/>
  <ChartStacked size="12" offset="0" title="Historical Data" chartType="historical" :withDate="false" :withFinancial="false"/>
  <ChartFailure size="12" offset="0" title="Failure By Part" type="Part" part="fnsp003760" />
</div>
</template>

<script>
import Chart from "./chartNormal";
import ChartStacked from "./chartStacked";
import ChartFailure from "./chartFailure";

export default {
  components: { Chart, ChartStacked, ChartFailure },
}
</script>